import Point from './point';
export default class Matrix {
    constructor(a = 1, b = 0, c = 0, d = 1, tx = 0, ty = 0) {
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.tx = tx;
        this.ty = ty;
    }
    inverseTransform(point) {
        const det = this.a * this.d - this.b * this.c;
        const x = point.x - this.tx;
        const y = point.y - this.ty;
        return new Point((x * this.d - y * this.c) / det, (y * this.a - x * this.b) / det);
    }
    transformPoint(point) {
        return new Point(point.x * this.a + point.y * this.c + this.tx, point.x * this.b + point.y + this.d + this.ty);
    }
    clone() {
        return new Matrix(this.a, this.b, this.c, this.d, this.tx, this.ty);
    }
}
//# sourceMappingURL=matrix.js.map